import { render, staticRenderFns } from "./GameRoomPage.vue?vue&type=template&id=0c6d2966&scoped=true"
import script from "./GameRoomPage.vue?vue&type=script&lang=ts"
export * from "./GameRoomPage.vue?vue&type=script&lang=ts"
import style0 from "./GameRoomPage.vue?vue&type=style&index=0&id=0c6d2966&prod&lang=css"
import style1 from "./GameRoomPage.vue?vue&type=style&index=1&id=0c6d2966&prod&lang=scss&scoped=true"
import style2 from "./GameRoomPage.vue?vue&type=style&index=2&id=0c6d2966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d2966",
  null
  
)

export default component.exports